import apiClient from './apiClient';

class CampaignClient {
    // 取得常駐活動玩家資訊
    getCampaignUserInfo = (spinSlug) => apiClient.get(`/spin/${spinSlug}/user-info`);

    // 前往任務
    goTask = (spinSlug, taskId) => apiClient.post(`/spin/${spinSlug}/go-task/${taskId}`);

    // 驗證任務
    verifyTask = (spinSlug, taskId) => apiClient.post(`/spin/${spinSlug}/verify-task/${taskId}`);

    // 轉動輪盤
    spin = (spinSlug) => apiClient.post(`/spin/${spinSlug}/spin`);

    // 取得中獎名單
    getWinnerList = (spinSlug) => apiClient.get(`/spin/${spinSlug}/winners`);
}

const campaignClient = new CampaignClient();

export default campaignClient;
